import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import tmpl from '@irb/irb-models/model-market-center/mmc-html-templates'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EditorMmcModelService} from '@irb/irb-editors/editor-mmc-model/editor-mmc-model.service';
import {IrbAppEvents} from '@irb/app.events';
import {AppService} from '@irb/app.service';
import {
    MmcInventoryActionsService
} from "@irb/irb-models/model-market-center/mmc-inventory/mmc-inventory-actions.service";
import {DialogInitialSettingsConfig} from "@irb/irb-initial-setup/dialog-initial-setup/dialog-initial-setup.component";

@Component({ standalone: false,
    selector: 'irb-sundry-acct-auth-dialog',
    templateUrl: './sundry-acct-auth-dialog.component.html',
    styleUrls: ['./sundry-acct-auth-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SundryAcctAuthDialogComponent implements OnInit {

    agreementTxt: string;
    chckBx: boolean = false;
    sundryAcct: string = '';
    disableBtn: boolean = true;
    sundyAcctInvalid: boolean = false;

    constructor(public dialogRef: MatDialogRef<SundryAcctAuthDialogComponent>,
                private editorMmcModelService: EditorMmcModelService,
                public as: AppService,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private mmcInventoryActionsService: MmcInventoryActionsService) {
        this.agreementTxt = tmpl.MMC_SUNDRY_ACCOUNT_AUTH_AGREEMENT;
    }

    ngOnInit(): void {
    }


    close() {
        this.dialogRef.close();
    }

    validateState() {
        this.disableBtn = !(this.sundryAcct.length > 0 && this.chckBx);
    }

    save() {
        const params: any = {accountNumber: this.sundryAcct};
        const nextService = this.mmcInventoryActionsService;//this.mdd && this.mdd.fromGrid ? this.mmcInventoryActionsService : this.editorMmcModelService;

        this.editorMmcModelService.setSundryAccount(params).subscribe((response: any) => {
            if (response.success) {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'success',
                    summary: 'Management Fee Account Authorization',
                    detail: 'Management Fee authorization signed.'
                });

                nextService.sundryPassGoNext(this.sundryAcct);
                this.close();
            } else {
                this.sundyAcctInvalid = true;
            }
        });
    }

}
